import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=58abd7f1"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=58abd7f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports